module.exports = __webpack_public_path__ + "static/guardianshipBrochure-b638a9aefb55cb68877bed083ae5afac.pdf";